import { observer } from "mobx-react-lite";
import Slider from "@mui/material/Slider";
const OpacitySlider = ({ opacity, setOpacity }) => {
  return (
    <Slider
      value={opacity}
      aria-label="label"
      valueLabelFormat={(value) => `${Math.round(value)}%`}
      valueLabelDisplay="auto"
      size="small"
      onChange={(e, value) => {
        setOpacity(value);
      }}
    />
  );
};

export default observer(OpacitySlider); // observer, cause layer is a LayerWrapper and opacity is observable;
